<template>
  <b-container>
    <div v-if="projet.html">
      <b-row>
        <b-col cols="9"><h2>{{ projet.titre }}</h2></b-col>
        <b-col cols="3" class="text-right">
          <span v-for="cat in categories" :key="'cat-'+cat" class="badge badge-info ml-1">{{ cat }}</span>
        </b-col>
      </b-row>
    </div>

    <div v-if="projet.description" class="my-2">
      <p>{{ projet.description }}</p>
    </div>

    <div>
      <div v-html="transformStaticFileURL(projet.html)"></div>
    </div>

    <div v-if="relatedOptions.length" class="my-3">
      <label class="mr-2">{{$t('related_projects')}}</label>
      <b-form-select v-model="selectedRelated" :options="relatedOptions" @change="onRelatedChange" size="sm"></b-form-select>
    </div>

  </b-container>

</template>

<script>
import {getProjet, getProjets} from "@/api";

export default {
name: "Project",
  data: function () {
    return {
      projet: {},
      allProjets: [],
      relatedOptions: [],
      selectedRelated: null
    };
  },
  computed: {
    categories() {
      const cat = this.projet && (this.projet.categorie || this.projet.categories);
      if (!cat) return [];
      if (Array.isArray(cat)) return cat;
      if (typeof cat === 'string') {
        // split by comma if needed
        if (cat.indexOf(',') >= 0) {
          return cat.split(',').map(s => s.trim()).filter(Boolean);
        }
        return [cat];
      }
      return [];
    }
  },
  methods: {
    loadProject() {
      const completePath = this.$route.path;
      getProjet(this.getAbsolutePath(completePath), this.$i18n.locale).then(
          (response) => {
            this.projet = response.data.projet || {};
            this.buildRelated();
          }
      )
    },
    loadAllProjects() {
      return getProjets(this.$i18n.locale).then(res => {
        this.allProjets = res.data.projets || [];
        this.buildRelated();
      });
    },
    buildRelated() {
      if (!this.projet || !this.projet.path || !this.categories.length || !this.allProjets.length) {
        this.relatedOptions = [];
        this.selectedRelated = null;
        return;
      }
      const currentPath = this.projet.path;
      const catSet = new Set(this.categories.map(c => c.toLowerCase()));
      const related = this.allProjets.filter(p => {
        if (!p || !p.path || p.path === currentPath) return false;
        const pc = p.categories || p.categorie;
        let arr = [];
        if (Array.isArray(pc)) arr = pc; else if (typeof pc === 'string') arr = pc.split(',').map(s=>s.trim());
        return arr.some(c => catSet.has(String(c).toLowerCase()));
      });
      this.relatedOptions = [{value: null, text: this.$t('choose_project')}, ...related.map(p => ({
        value: p.path.replace('projets/', ''),
        text: p.titre
      }))];

      this.selectedRelated = null;
    },
    onRelatedChange(val) {
      if (val) {
        this.$router.push(val);
      }
    },
    getAbsolutePath(pathString) {
      return pathString.substr(9, pathString.length - 9);
    },
    transformStaticFileURL(body) {
      if (!body) return '';
      return body.replace('?/static/?g', process.env.VUE_APP_SITE_API_URL+'$&');
    }
  },
  watch: {
    '$route.path'() {
      this.loadProject();
    },
    '$i18n.locale'() {
      this.loadProject();
      this.loadAllProjects();
    }
  },
  mounted() {
    this.loadProject();
    this.loadAllProjects();
  }
}
</script>

<style scoped>

</style>